import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from 'components/Typography';
import { type FlatPackProps } from './types';
import { getPackInfo } from './helpers';
import PackImage from './PackImage';

import {
  FlatPackContainer,
  FlatPackDescription,
  FlatPackPrice,
  FlatPackSeparator,
  FlatPackTitle,
  MinterRoyalty,
} from './styled';

const FlatPack: FC<FlatPackProps> = ({
  packType = 'common',
  packDistribution,
  price,
  currency = 'FUSD',
  boughtFor,
  children,
  creator,
  title,
  cards,
}) => {
  const { t } = useTranslation();
  let packTitle = packType.slice(-5) === '_plus' ? 'reward' : packType;
  if (packTitle === 'mystery') {
    packTitle = 'mystery pack';
  }

  return (
    <FlatPackContainer>
      <PackImage
        data-test-id={`pack_image_${packType}`}
        creator={creator}
        title={title}
        type={packType}
      />
      <FlatPackDescription data-test-id="flat_pack_description" $alignTop={!boughtFor && packTitle !== 'reward'}>
        <FlatPackTitle textColor="white" bold uppercase>
          {packTitle}
        </FlatPackTitle>
        {getPackInfo(packType, packDistribution, cards)}
        {boughtFor && (
          <Typography textColor="lightGray" size="unmedia16">
            {currency === 'FUSD' && t('wallet.packs.boughtForDollars', { boughtFor })}
            {currency === 'FLOW' && t('wallet.packs.boughtForFlow', { boughtFor })}
          </Typography>
        )}
        {price && (
          <FlatPackPrice textColor="white" size="title" bold uppercase>
            {currency === 'FUSD' && `$${price.toFixed(2)}`}
            {currency === 'FLOW' && `${price.toFixed(2)} FLOW`}
          </FlatPackPrice>
        )}
        {children}
      </FlatPackDescription>
      {!boughtFor && packTitle !== 'reward' && <FlatPackSeparator />}
      {!boughtFor && packTitle !== 'reward' && (
        <MinterRoyalty>
          {t('wallet.packs.openTextStart')}
          <strong>{t('wallet.packs.mintingRoyalty', { royalty: 1 })}</strong>
          {t('wallet.packs.openTextEnd')}
        </MinterRoyalty>
      )}
    </FlatPackContainer>
  );
};

export default FlatPack;
